import MarkdownComponent from 'components/shared/MarkdownComponent';
import { UIOfferWhenHighlights } from 'interfaces/ui/ui-offer-when-highlights';
import { UIOfferWhenSection } from 'interfaces/ui/ui-offer-when-section';
import { StyledJobOfferLongText } from '../JobOfferLongText.styled';
import {
  StyledWhenHighlights,
  StyledWhenHighlightsIntro,
  StyledWhenHighlightsList
} from './WhenHighlights.styled';
import WhenHighlightsItem from './WhenHighlightsItem';

const WhenHighlights = ({
  highlightsIntro,
  highlights,
  migratedToMarkdown
}: UIOfferWhenSection) => {
  return (
    <StyledWhenHighlights>
      {highlightsIntro && (
        <>
          {migratedToMarkdown ? (
            <StyledWhenHighlightsIntro>
              <StyledJobOfferLongText>
                <MarkdownComponent content={highlightsIntro || ''} />
              </StyledJobOfferLongText>
            </StyledWhenHighlightsIntro>
          ) : (
            <StyledWhenHighlightsIntro
              dangerouslySetInnerHTML={{ __html: highlightsIntro || '' }}
            ></StyledWhenHighlightsIntro>
          )}
        </>
      )}
      <StyledWhenHighlightsList>
        {highlights &&
          highlights.map((h: UIOfferWhenHighlights, i: number) => (
            <WhenHighlightsItem
              key={i}
              highlights={h}
              migratedToMarkdown={migratedToMarkdown}
            />
          ))}
      </StyledWhenHighlightsList>
    </StyledWhenHighlights>
  );
};

export default WhenHighlights;
